import { createGeminiImage, fileToBase64, isGeminiAvailable } from './gemini-client.js';

const form = document.querySelector('form[data-portrait-form]');
const fileInput = document.querySelector('#portrait-photo');
const fileLabel = document.querySelector('[data-file-label]');
const backgroundSelect = document.querySelector('#portrait-background');
const toneSelect = document.querySelector('#portrait-tone');
const statusEl = document.querySelector('[data-status]');
const originalFrame = document.querySelector('[data-original-img]');
const previewFrame = document.querySelector('[data-result-img]');
const downloadBtn = document.querySelector('[data-download]');
const submitBtn = form?.querySelector('button[type="submit"]');
let originalObjectUrl = null;
let geminiReady = true;

const BACKGROUND_PROMPTS = {
  gallery:
    'Set the rabbit against a softly lit gallery wall with framed art, linen texture, and brass picture light.',
  midnight:
    'Place the rabbit in front of a midnight-indigo velvet drape with subtle spot lighting and cinematic rim light.',
  teahouse:
    'Seat the rabbit in a tatami tea room with shoji panels, muted beige walls, and delicate ikebana arrangement.'
};

const TONE_PROMPTS = {
  classic: 'formal portrait, medium format photography, shallow depth of field, studio lens flare minimal.',
  regal: 'grand royal portrait, baroque-inspired, painterly highlights, ornate details.',
  modern: 'contemporary lifestyle editorial, matte finish, balanced color grading.'
};

function buildPrompt(backgroundKey, toneKey) {
  return `Create a formal portrait of the rabbit keeping the same expression and fur markings. ${
    BACKGROUND_PROMPTS[backgroundKey]
  } ${TONE_PROMPTS[toneKey]} Emphasize glossy eyes and whisker detail.`;
}

function setStatus(message, isError = false) {
  statusEl.textContent = message;
  statusEl.classList.toggle('error', isError);
}

function updateOriginalPreview(file) {
  if (originalObjectUrl) {
    URL.revokeObjectURL(originalObjectUrl);
    originalObjectUrl = null;
  }

  if (!file) {
    originalFrame.style.backgroundImage = '';
    originalFrame.classList.add('placeholder');
    return;
  }

  originalObjectUrl = URL.createObjectURL(file);
  originalFrame.style.backgroundImage = `url(${originalObjectUrl})`;
  originalFrame.classList.remove('placeholder');
}

function setResult(base64) {
  if (!base64) {
    previewFrame.style.backgroundImage = '';
    previewFrame.classList.add('placeholder');
    downloadBtn.classList.add('is-hidden');
    return;
  }
  const dataUrl = `data:image/png;base64,${base64}`;
  previewFrame.style.backgroundImage = `url(${dataUrl})`;
  previewFrame.classList.remove('placeholder');
  downloadBtn.href = dataUrl;
  downloadBtn.download = 'croissant-portrait.png';
  downloadBtn.classList.remove('is-hidden');
}

async function initGeminiAvailability() {
  if (!form || !statusEl) return;
  geminiReady = await isGeminiAvailable();
  if (!geminiReady) {
    submitBtn?.setAttribute('disabled', 'true');
    setStatus('Image generation is offline right now. Tools are in preview mode.');
    form.classList.add('tool-disabled');
  }
}

fileInput.addEventListener('change', () => {
  const file = fileInput.files?.[0];
  if (fileLabel) {
    fileLabel.textContent = file ? file.name : 'No file selected';
  }
  updateOriginalPreview(file || null);
});

form.addEventListener('submit', async (event) => {
  event.preventDefault();
  if (!geminiReady) {
    setStatus('Image generation is offline. Please check back soon.', true);
    return;
  }
  const file = fileInput.files?.[0];
  if (!file) {
    setStatus('Please upload a rabbit photo.', true);
    return;
  }
  if (file.size > 8 * 1024 * 1024) {
    setStatus('Image exceeds 8MB. Please compress and retry.', true);
    return;
  }

  const prompt = buildPrompt(backgroundSelect.value, toneSelect.value);

  try {
    setStatus('Generating a formal portrait. This may take a few seconds…');
    setResult('');
    const { base64, mimeType } = await fileToBase64(file);
    const output = await createGeminiImage({
      prompt,
      base64Image: base64,
      mimeType
    });
    setResult(output);
    setStatus('Portrait ready! Download the PNG below.');
  } catch (error) {
    console.error(error);
    setStatus(error.message || 'Generation failed. Please try again.', true);
    setResult('');
  }
});

initGeminiAvailability();
